var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"core-footer","absolute":"","height":"82"}})
}
var staticRenderFns = []

export { render, staticRenderFns }